import { useOptimizedChat } from './useOptimizedChat';

/**
 * Lightweight hook to access chat unread count
 * Reuses existing useOptimizedChat subscription without additional queries
 */
export function useChatUnreadCount() {
  const { totalUnreadCount, loading } = useOptimizedChat();
  
  return {
    unreadCount: totalUnreadCount,
    hasUnread: totalUnreadCount > 0,
    loading
  };
}
